import {Box, Container, Grid} from '@mui/material';
import CookieConsentDialog from '../cookieConsentDialog/CookieConsentDialog';
import FooterAbout from './FooterAbout';
import FooterCopyright from './FooterCopyright';
import FooterLegal from './FooterLegal';
import FooterSocial from './FooterSocial';

export default function Footer() {
  const items = [FooterAbout, FooterLegal, FooterSocial];
  return (
    <Box component="footer" sx={{bgcolor: 'background.paper', py: 6}}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-evenly">
          {items.map((c) => (
            <Grid size={{xs: 12, sm: 6, md: Math.floor(12 / items.length)}} key={`Footer-${c.name}`}>
              {c()}
            </Grid>
          ))}
        </Grid>
        <FooterCopyright />
      </Container>
      <CookieConsentDialog />
    </Box>
  );
}
